<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <b-card no-body>
        <b-tabs pills card>
          <b-tab title="Item Details" active>
            <b-container fluid>
              <b-row class="my-1">
                <b-col sm="12">
                  <label>Title:</label>
                  <b-form-input
                    id="input-small"
                    v-model="form.title"
                    size="sm"
                    placeholder="Enter title"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <label
                    >Category
                    <b-button size="sm" @click="openCategory"
                      ><i class="fa fa-plus-square"></i
                    ></b-button>
                  </label>
                  <select-with-search
                    :search_api="categories_path.SEARCH_CATEGORY"
                    :selected_data="[form.category_ref_id]"
                    selected_by="ref_id"
                    track_by="ref_id"
                    display="name"
                    @selectedOption="(v) => (form.category = v)"
                  ></select-with-search>
                  <b-modal id="bv-add-category" size="sm" hide-footer>
                    <addCategory></addCategory>
                  </b-modal>
                </b-col>
                <b-col sm="6">
                  <label>Food Type</label>
                  <select-with-search
                    :options-data="food_type_options"
                    :selected_data="selected_food_types"
                    selected_by="key"
                    track_by="key"
                    display="value"
                    :search_without_api="true"
                    @selectedOption="(v) => (form.food_type = v)"
                  ></select-with-search>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <label
                    >Default Sales Price:
                    <i
                      class="fa fa-info-circle"
                      v-b-tooltip
                      title="Price of the item as it's displayed to your customers"
                    ></i
                  ></label>
                  <b-input-group size="sm" prepend="₹">
                    <b-form-input
                      id="input-small"
                      v-model="form.price"
                      placeholder="Enter Price"
                      type="number"
                    ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col sm="4">
                  <label>Weight</label>
                  <b-form-input
                    id="input-small"
                    v-model="form.weight"
                    placeholder="Enter Weight"
                    type="number"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="12" class="ml-0">
                  <label>description:</label>
                </b-col>
                <b-col sm="12">
                  <b-textarea
                    v-model="form.description"
                    size="sm"
                    rows="3"
                  ></b-textarea>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <label>Recommended</label>
                  <b-checkbox switch v-model="form.recommended"></b-checkbox>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <label>Images</label>
                  <template>
                    <b-button
                      class="ml-2"
                      size="sm"
                      @click="
                        () =>
                          form.images.push({ tag: '', img_url: '', url: '' })
                      "
                      ><i class="fa fa-plus-square"></i
                    ></b-button>
                    <b-row v-for="(im, imk) in form.images" :key="imk">
                      <b-col sm="4">
                        {{ im.tag }}
                        <select-with-search
                          :search_without_api="true"
                          :selected_data="im.tag !== undefined ? [im.tag] : []"
                          selected_by="key"
                          track_by="key"
                          display="value"
                          :options-data="img_tags"
                          @selectedOption="(v) => (im.tag = v)"
                        ></select-with-search>
                      </b-col>
                      <b-col sm="4">
                        <b-img
                          v-if="im.img_url != ''"
                          height="60"
                          :src="cdn + '/' + im.img_url"
                        ></b-img>
                        <b-form-file
                          v-if="im.img_url == ''"
                          accept="image/*"
                          @change="saveImage($event, imk)"
                        ></b-form-file>
                      </b-col>
                      <b-col sm="4">
                        <b-button size="sm"
                          ><i class="fa fa-trash" @click="deleteImage(imk)"></i
                        ></b-button>
                      </b-col>
                    </b-row>
                  </template>
                </b-col>
              </b-row>
              <b-row class="my-1 mt-2">
                <b-col sm="12">
                  <b-button @click="saveItem" class="btn btn-success"
                    >Submit</b-button
                  >
                </b-col>
              </b-row>
            </b-container>
          </b-tab>
          <b-tab title="Locations">
            <locations :selected_item="selected_item"></locations>
          </b-tab>
          <b-tab v-if="selected_item" title="Modifier Groups">
            <modifierGroups :selected_item="selected_item"></modifierGroups>
          </b-tab>
          <!--          <b-tab v-if="selected_item" title="Modifier">-->
          <!--            <modifiers :selected_item="selected_item"></modifiers>-->
          <!--          </b-tab>-->
          <b-tab v-if="selected_item" title="Gravies">
            <gravies :selected_item="selected_item"></gravies>
          </b-tab>
          <b-tab v-if="selected_item" title="Packaging">
            <packaging :selected_item="selected_item"></packaging>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  AggregatorPath,
  categories_path,
  ImagesPath,
  ItemPath,
} from "../../../../path";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import addCategory from "../Categories/add.vue";
import modifierGroups from "./modifier_groups.vue";
import Gravies from "@/views/pages/Dilfoods/items/gravies.vue";
import Packaging from "@/views/pages/Dilfoods/items/packaging.vue";
import locations from "@/views/pages/Dilfoods/items/location.vue";

export default {
  name: "add",
  computed: {
    categories_path() {
      return categories_path;
    },
  },
  components: {
    Packaging,
    Gravies,
    SelectWithSearch,
    addCategory,
    modifierGroups,
    locations,
  },
  props: ["selected_item"],
  data() {
    return {
      form: {
        images: [
          {
            tag: "",
            img_url: "",
            url: "",
          },
        ],
        active: true,
      },
      selected_food_types: [],
      img_tags: [
        { key: "default", value: "Default" },
        { key: "zomato", value: "Zomato" },
        { key: "swiggy", value: "Swiggy" },
        { key: "ubereats", value: "Ubereats" },
        { key: "dotpe", value: "Dotpe" },
        { key: "amazon", value: "Amazon" },
        { key: "dunzo", value: "Dunzo" },
      ],
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      cdn: process.env.VUE_APP_AWS_CDN,
      filters: [],
      food_type_options: [
        { key: 1, value: "Vegetarian" },
        { key: 2, value: "Non-vegetarian" },
        { key: 3, value: "Eggetarian" },
        { key: 4, value: "Not specified" },
      ],
      aggregators: [],
      fulfillment_modes: [
        { key: "delivery", value: "Delivery" },
        { key: "pickup", value: "Pickup" },
      ],
    };
  },
  watch: {
    // selected_item: {
    //   deep : true,
    //   handler(v){
    //     console.log(v);
    //     this.form = v;
    //     this.selected_food_types = [this.selected_item.food_type];
    //   }
    // }
  },
  mounted() {
    if (this.selected_item) {
      this.form = this.selected_item;
      this.selected_food_types = [parseInt(this.selected_item.food_type)];
    }
    this.getAggregators();
  },
  methods: {
    openCategory() {
      this.$bvModal.show("bv-add-category");
    },
    async getAggregators() {
      try {
        let res = await axios.get(this.baseUrl + AggregatorPath.getAggregators);
        if (res.data.status) {
          this.aggregators = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async saveItem() {
      try {
        let res = await axios.post(this.baseUrl + ItemPath.ALL, this.form);
        if (res.data.status == true) {
          this.$bvToast.toast("Successfully added", {
            title: `Item added`,
            variant: "success",
            solid: true,
          });
          this.$bvModal.hide("bv-add-item");
          this.$emit("update");
        }
      } catch (e) {
        console.log(e);
      }
    },
    async saveImage(e, imk) {
      try {
        let formData = new FormData();
        formData.append("file", e.target.files[0]);
        formData.append("folder", "items");
        let res = await axios.post(
          this.baseUrl + ImagesPath.UPLOAD_IMAGE,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status) {
          this.form.images[imk].img_url = res.data.data.file;
          this.form.images[imk].url = res.data.data.file;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async deleteImage(imk) {
      try {
        let res = await axios.post(this.baseUrl + ImagesPath.DELETE_IMAGE, {
          path: this.form.images[imk].img_url,
        });
        console.log(imk);
        this.form.images.splice(imk, 1);
        console.log(res);
      } catch (e) {
        this.form.images.splice(imk, 1);
        console.log(e);
      }
    },
  },
};
</script>

<style></style>
